<template>
    <div class="form-group">
        <label class="form-label section-title">{{ $t('messages.status') }}</label>
        <select class="form-select" :value="value" @change="$emit('input', $event.target.value)">
            <option value="active">{{ $t('messages.active_status') }}</option>
            <option value="paused">{{ $t('messages.paused_status') }}</option>
            <option value="completed">{{ $t('messages.completed_status') }}</option>
        </select>
    </div>
</template>

<script>
export default {
    name: "CampaignStatus",
    props: {
        value: {
            type: String,
            default: 'active'
        }
    }
};
</script>

